import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Check, X, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      confirmEmail();
    } else {
      setStatus('error');
    }
  }, [token]);

  const confirmEmail = async () => {
    try {
      // Backend contract: GET /api/auth/confirm-email?token=<token>
      await axios.get(`${API}/auth/confirm-email`, { params: { token } });
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)] px-6">
      <div className="card p-10 text-center max-w-md w-full">
        {status === 'verifying' && (
          <>
            <div className="spinner mx-auto mb-4"></div>
            <h2 className="font-serif text-2xl mb-2">Verifying your email...</h2>
            <p className="text-sm text-[var(--color-muted)]">Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4 bg-green-50">
              <Check className="w-7 h-7 text-green-600" />
            </div>
            <h2 className="font-serif text-2xl mb-2">Email confirmed!</h2>
            <p className="text-sm text-[var(--color-muted)] mb-6">Your account is now fully activated.</p>
            <button onClick={() => navigate('/')} className="btn btn-primary">Go to Stilos</button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4 bg-red-50">
              <X className="w-7 h-7 text-red-600" />
            </div>
            <h2 className="font-serif text-2xl mb-2">Verification failed</h2>
            <p className="text-sm text-[var(--color-muted)] mb-6">The link may have expired or is invalid.</p>
            <button onClick={() => navigate('/')} className="btn btn-primary">Go to Stilos</button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmail;
